<template>
    <div
        :class="{
            user: true,
            'user--slider': isSelected,
            'user--not-selected': !isSelected,
        }"
    >
        <div class="user__avatar">
            <avatar :size="25" :src="user.picture" :username="user.name" />
        </div>
        <div class="user__info">
            <span class="name">{{ user.name }}</span>
            <i
                v-if="showCalibrationIndicator"
                v-b-tooltip.hover
                :title="$t('nBox.userCalibrated')"
                class="calibration fas fa-check"
            />
        </div>
    </div>
</template>
<script>
import Avatar from 'vue-avatar'
export default {
    components: {
        Avatar,
    },
    props: {
        user: Object,
        nBoxId: Number,
        visualizationType: String,
    },
    computed: {
        isSelected() {
            const { nBox, user } = this.$store.state.nBoxesReport.slider
            const isTheSameNBox = nBox ? nBox.id == this.nBoxId : false
            const isTheSameUser = user ? user.id == this.user.id : false
            return isTheSameNBox && isTheSameUser
        },
        showCalibrationIndicator() {
            return (
                this.user.hasCalibration &&
                this.visualizationType == 'calibrated'
            )
        },
    },
}
</script>
<style lang="scss" scoped>
$blue: #009bdb;

.user {
    display: flex;
    cursor: pointer;
    position: relative;
    padding: 5px;
    border-radius: 5px;
    align-items: center;
    background-color: white;
    box-shadow: 0 1px 2px 1px rgb(206, 211, 215);

    &::before {
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        content: '';
        position: absolute;
        border-radius: 5px;
        opacity: 0;
        transition: 0.3s ease all;
    }

    .user__avatar {
        min-width: 20px;
        margin-left: 10px;
        margin-right: 20px;
    }

    .user__info {
        display: flex;
        align-items: center;
        justify-content: space-between;
        width: 100%;

        .name {
            font-weight: 600;
        }

        .calibration {
            padding: 5px;
            color: $blue;
        }
    }
}

$base-border: solid $blue;

.user--slider {
    &::before {
        opacity: 1;
        transition: none;
        border: 2px $base-border;
    }
}

.user--not-selected:hover {
    &::before {
        opacity: 1;
        border: 1px $base-border;
    }
}
</style>
